import { render, staticRenderFns } from "./ktextbox.vue?vue&type=template&id=38f5b8b7&"
import script from "./ktextbox.vue?vue&type=script&lang=js&"
export * from "./ktextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports